import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsThreeDotJsComponent } from './simple-icons-three-dot-js.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsThreeDotJsComponent ],
    exports:      [ SimpleIconsThreeDotJsComponent ],
    bootstrap:    []
})
export class SimpleIconsThreeDotJsModule {}
